import React, { lazy, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import {ICONS} from '../shared/icons';
import Icon from '../shared/iconComponent';

const Modal = ({ isModalOpen, type, payload, title, reviewScore, close }) => {

	const importModalComponent = componentType => lazy( () => import( `${componentType}` ).catch(( error ) => console.log( error ) ) );
	const [component, setComponent] = useState(null);
	
	useEffect(() => {

		async function loadComponent() {
			const Component = await importModalComponent( type );
			setComponent( <Component payload={payload} close={close} /> )
		}

		if( type != null ) {
			loadComponent();
		}

		return function cleanup() {
			setComponent(null);
		};
	}, [ type ])

	useEffect(() => {
		if( isModalOpen ) {
			const scrollY = window.scrollY;
			document.body.classList.add('modal-open');
			//document.body.style.position = 'fixed';
			document.body.style.top = `-${scrollY}px`;
			
		}
	}, [ isModalOpen ])

	const closeModal = () => {
		close()
		document.body.classList.remove('modal-open');
		const scrollY = document.body.style.top
		//document.body.style.position = ''
		document.body.style.top = ''
		window.scrollTo(0, parseInt(scrollY || '0') * -1)
	}

	const class_name = title != null && typeof title == 'string' ? title.toLowerCase() : null;

	return isModalOpen ? ReactDOM.createPortal(
		<div className={payload.modalClass != undefined ? `${payload.modalClass} modal visible` : `modal visible`}>
			<div className="modal-overlay"></div>
			<div className={"modal-content wide radius " + class_name}>
				<div className="pd-md">
					<div className="align-content vertical start split modal-header">
						<div className="align-content vertical center">
							<div className="modal-back">
								<a onClick={closeModal} >
									<span className="icon icon-chevron-left black"></span>
								</a>
							</div>
							<div className="modal-title">
								<h2>
									{title}
									{payload.reviewScore && payload.reviewScore != 0 ?
										<div className="stars modal-stars mg-l" style={{'--rating': payload.reviewScore}}></div>
									: null }
								</h2>
								
							</div>
						</div>
						
						<a className="close-button" onClick={closeModal} >
							<div className="icon-holder round border black no-mg">
								<span className="icon icon-close black"></span>
							</div>
						</a>
						
					</div>
			
					<React.Suspense fallback='Loading component...'>
						{component}
					</React.Suspense>
				</div>
			</div>
		</div>, document.body
	) : null;
}

export default Modal;
